import React, { useRef } from "react";
import { Typography, Box, List, ListItem, ListItemText, Divider, Grid, Button, Chip } from "@mui/material";
import { ErrorOutline as ErrorOutlineIcon } from "@mui/icons-material";
import { Formik, Form } from "formik";
import Signature from "../../../../../common/signature/signature";

const AnyOtherRules = ({ updateFormData, prevStep, handleSubmit }) => {
  const rules = [
    "Staff are to follow the rules to keep you safe and care for you",
    "Staff may at times need to search your bedroom, you will be told about this before it occurs",
    "Deep clean of your bedroom is to be completed every Sunday",
    "Deep clean of your bedroom is to be completed every Sunday",
  ];

  const signatureRef = useRef(null);

  // Initial form values (this is necessary to avoid the error)
  const initialValues = {
    agree: true, // This must be initialized in Formik
  };

  return (
    <Formik
      initialValues={initialValues} // Initial values are required here
      onSubmit={(values) => {
        const signatureData = signatureRef.current.getSignatureData();
        if (!signatureData) {
          alert("Please provide a signature");
          return;
        }

        const formData = { ...values, signature: signatureData }; // Include signature in form values
        updateFormData({ rulesInfo: formData }); // Update form data in the parent state

        handleSubmit(); // Final submit with all forms' data
      }}
    >
      {() => (
        <Form className='house-rules-container'>
          <Box className='header-section-house'>
            <Chip label='Admission' />
            <Typography sx={{ fontSize: "22px", fontWeight: "bold", color: "black" }} align='left' mt={1}>
              House Rules
            </Typography>
            <br />
            <Divider className='divider' />
          </Box>
          <Box className='content-section'>
            <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: "black" }} align='left'>
              Any Other Rules
            </Typography>
            <Typography sx={{ fontSize: "14px" }}>
              "Rules are in place for your safety and well-being. Follow them to maintain a positive living
              environment."
            </Typography>
            <List className='rules-list'>
              {rules.map((rule, index) => (
                <ListItem key={index} className='rule-item'>
                  <ListItemText primary={<Typography sx={{ fontSize: "14px", color: "black" }}>{rule}</Typography>} />
                </ListItem>
              ))}
            </List>
          </Box>

          <Box className='agreement-section' display='flex' alignItems='center'>
            <ErrorOutlineIcon color='primary' />
            <Typography sx={{ fontSize: "14px" }}>
              These rules are not an extensive list of everything within the home and rules can change at any time at
              staff and your requests. Please listen to any member of staff as they will let you know of any changes. If
              you have any questions regarding any rules, please feel free to talk to your staff or Home Manager who may
              be able to help.
            </Typography>
          </Box>

          <Box className='signature-box'>
            <Signature ref={signatureRef} />
            <Typography align='right'>
              <Grid container>
                <Grid>
                  <Typography sx={{ fontSize: "14px", color: "#FFB700" }}>Venorox </Typography>
                </Grid>
                <Grid>
                  <Typography sx={{ fontSize: "14px" }}>/ Signature</Typography>
                </Grid>
              </Grid>
              <Grid className='clear-signature-button'>
                <Button variant='outlined' onClick={() => signatureRef.current?.clearSignature()}>
                  Clear
                </Button>
              </Grid>
            </Typography>
          </Box>

          <Grid container justifyContent='space-between' alignItems='center' mt={2}>
            <Grid item>
              <Button type='button' variant='contained' color='primary' onClick={prevStep}>
                Previous
              </Button>
            </Grid>
            <Grid item>
              <Button type='submit' variant='contained' color='primary' onClick={handleSubmit}>
                Submit
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default AnyOtherRules;
